import { Box, Icon } from '@palmetto/palmetto-components';

import { useMaintenancePortalLink } from '../hooks/useMaintenancePortalLink';

export function MaintenancePortalLink({
  variant,
  onClick,
}: {
  variant: 'topNav' | 'user-menu-item';
  onClick?: () => void;
}) {
  const { isEnabled, url } = useMaintenancePortalLink();

  if (!isEnabled) {
    return null;
  }

  return (
    <>
      {variant === 'topNav' ? (
        <>
          <Box
            style={{ marginRight: '8px' }}
            className="outline-zinc-200 w-0 self-stretch outline outline-1 outline-offset-[-0.50px]"
          />
          <Box
            as="a"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            fontSize={{ base: 'sm', desktop: 'md' }}
            color="body-primary"
            textAlign="left"
            alignItems="center"
            background="primary"
            direction="row"
            childGap="md"
            cursor="pointer"
            onClick={onClick}
            hover={{
              color: 'contrast',
            }}
          >
            <>
              <Box fontSize="sm" style={{ padding: '6px' }}>
                {'Maintenance Portal'}
              </Box>
              <Icon name="launch-app" size="sm" />
            </>
          </Box>
        </>
      ) : (
        <Box
          as="a"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          cursor="pointer"
          padding={{ base: 'xs sm', desktop: 'sm' }}
          background="transparent"
          borderWidth="0"
          color="body-primary"
          hover={{ background: 'secondary' }}
          radius="sm"
          textAlign="left"
          width="100"
          onClick={onClick}
          className="nav-link"
        >
          <Box direction="row" alignItems="center" gap="xl">
            Go to Maintenance Portal
            <Icon name="launch-app" size="sm" />
          </Box>
        </Box>
      )}
    </>
  );
}
